import React from "react";
import {useProjectTranslations} from "@i18n/i18nUtils";
import {i18n} from "@i18n/i18n";

export default function I18nTestPage() {
    const {t} = useProjectTranslations();

    return (
        <div style={{padding: 24}}>
            <h1>I18n test</h1>

            <p style={{opacity: 0.7}}>
                lang: <strong>{i18n.language}</strong>
            </p>

            <section style={{marginTop: 24}}>
                <h2>Placeholders</h2>

                <p>
                    {t("_test_placeholder_simple", {name: "Mario"})}
                </p>

                <p>
                    {t("_test_placeholder_multi", {
                        name: "Mario",
                        orderId: "ORD-123",
                        status: "ready",
                    })}
                </p>

                <p dangerouslySetInnerHTML={{__html: t("_test_placeholder_html", {name: "Mario"})}} />
            </section>

            <section style={{marginTop: 24}}>
                <h2>Pluralization</h2>

                <p>{t("_test_plural_items", {count: 0})}</p>
                <p>{t("_test_plural_items", {count: 1})}</p>
                <p>{t("_test_plural_items", {count: 5})}</p>

                <p>{t("_test_plural_points", {count: 1})}</p>
                <p>{t("_test_plural_points", {count: 10})}</p>
            </section>
        </div>
    );
}
